import { createAction } from '@reduxjs/toolkit';

export const CALL_STACK_REBASE_ACTION_TYPE = 'saga/callStackRebase';
export const callStackRebaseAction = createAction(CALL_STACK_REBASE_ACTION_TYPE);
